export const ACCOUNT_SCOPES = 'account.apps.read account.apps.revoke';
export const ACCOUNT_SIGN_IN = 'Sign in again to disconnect apps';

export class AccountAuthorizationRequired extends Error {
  readonly code = 'account-authorization-required';
  constructor() {
    super(ACCOUNT_SIGN_IN);
  }
}

export function accountAuthorizationNeeded(error: unknown): boolean {
  const code = error as { code?: string; error?: string; params?: { error?: string } } | null;
  return [
    'invalid_grant',
    'invalid_scope',
    'invalid_target',
    'unauthorized_client',
    'login_required',
    'consent_required',
    'interaction_required',
    'account-authorization-required',
  ].includes(code?.params?.error ?? code?.error ?? code?.code ?? '');
}
